import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Flex, TooltipMenu, Icon } from '@haldor/ui';
import DateTime from '_class/DateTime';
import DOMPurify from 'dompurify';
var Message = function Message(props) {
  var getName = function getName() {
    if (props.user == null) {
      return null;
    }
    var name = props.user.firstName;
    if (props.user.lastName != null) {
      name += ' ' + props.user.lastName;
    }
    return name + ' • ';
  };
  var className = 'conversation message';
  var timestampClass = 'timestamp';
  if (props.me) {
    className += ' me';
  }
  if (props.narrow) {
    className += ' narrow';
  }
  if (props.multipleDown) {
    className += ' no-radius-bottom';
  }
  if (props.multipleUp) {
    className += ' no-radius-top';
  }
  if (!props.me) {
    timestampClass += ' left';
  }
  if (props.me) {
    timestampClass += ' right';
  }

  // if message.type == 'file' the message.text will be 'fileName | fileId'. Separate them and use fileId to render a link to the file, and fileName as the text for the link
  var fileName = '';
  var fileId = '';
  if (props.message.type === 'file' && props.message.text) {
    var _props$message$text$s = props.message.text.split(' | ');
    var _props$message$text$s2 = _slicedToArray(_props$message$text$s, 2);
    fileName = _props$message$text$s2[0];
    fileId = _props$message$text$s2[1];
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Flex, {
    end: props.me,
    center: true
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, props.flagged != null ? /*#__PURE__*/React.createElement("div", {
    className: "flag-badge"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Flag"
  }), props.flagged) : props.message.type === 'file' ? /*#__PURE__*/React.createElement("a", {
    href: props.message.url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "file-message-link"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "File"
  }), /*#__PURE__*/React.createElement("span", {
    className: "file-message-name"
  }, fileName || 'File'), /*#__PURE__*/React.createElement(Icon, {
    name: "Download"
  })) : /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(props.message.text)
    }
  }), props["new"] && !props.me ? /*#__PURE__*/React.createElement("div", {
    className: "unread-badge"
  }) : null, props.message.type === 'text' && props.actions != null && props.actions.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "action-menu"
  }, /*#__PURE__*/React.createElement(TooltipMenu, {
    trigger: "⋯"
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
      onClick: action.onClick,
      key: 'action-' + index
    }, action.label);
  }))) : null)), /*#__PURE__*/React.createElement("div", {
    className: timestampClass
  }, props.sender != null ? props.sender + ' • ' : null, getName(), new DateTime(props.time).getTimeStampHours()));
};
export default Message;